// assets/custom-empaque.js
(function () {
  const EMPAQUE_VARIANT_ID = 51561265922343;
  let isProcessing = false;

  // ── Leer carrito ─────────────────────────────────────────────────────────
  async function getCart() {
    const res = await fetch('/cart.js');
    return res.json();
  }

  // ── Agregar empaque ───────────────────────────────────────────────────────
  async function addEmpaque() {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: EMPAQUE_VARIANT_ID, quantity: 1 })
    });
  }

  // ── Quitar empaque ────────────────────────────────────────────────────────
  async function removeEmpaque() {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: { [EMPAQUE_VARIANT_ID]: 0 } })
    });
  }

  // ── Notificar a cart-items-component que re-renderice ─────────────────────
  // Usamos CartUpdateEvent (NO CartAddEvent) para que el drawer no se abra.
  // sections:{} vacío hace que cart-items-component llame sectionRenderer.renderSection
  async function notifyHorizon(cart) {
    try {
      const { CartUpdateEvent } = await import('@theme/events');
      const event = new CartUpdateEvent(cart, '', {
        itemCount: cart.item_count,
        source: 'empaque-sync',
        sections: {}
      });
      document.dispatchEvent(event);
    } catch (e) {
      console.warn('[Empaque] No se pudo notificar a Horizon:', e);
    }
  }

  // ── Lógica principal ──────────────────────────────────────────────────────
  async function syncEmpaque() {
    if (isProcessing) return;
    isProcessing = true;

    try {
      const cart      = await getCart();
      const items     = cart.items || [];
      const empaque   = items.find(i => i.variant_id === EMPAQUE_VARIANT_ID);
      const realItems = items.filter(i => i.variant_id !== EMPAQUE_VARIANT_ID);

      if (realItems.length > 0 && !empaque) {
        // Faltan materiales de empaque → agregar
        await addEmpaque();
        const updatedCart = await getCart();
        await notifyHorizon(updatedCart);

      } else if (realItems.length === 0 && empaque) {
        // Carrito vacío real → quitar empaque
        await removeEmpaque();
        const updatedCart = await getCart();
        await notifyHorizon(updatedCart);
      }

    } catch (err) {
      console.error('[Empaque] Error en sync:', err);
    } finally {
      isProcessing = false;
    }
  }

  // ── Interceptor de fetch ──────────────────────────────────────────────────
  const originalFetch = window.fetch;

  window.fetch = function (...args) {
    const url = typeof args[0] === 'string'
      ? args[0]
      : (args[0]?.url || '');

    const isCartMutation = /\/cart\/(add|change|update|clear)/.test(url);
    const promise = originalFetch.apply(this, args);

    if (isCartMutation) {
      promise
        .then(() => setTimeout(syncEmpaque, 500))
        .catch(() => {});
    }

    return promise;
  };

  // ── Validación inicial (carrito persistente al recargar página) ───────────
  document.addEventListener('DOMContentLoaded', syncEmpaque);

})();